import React from 'react'
import { useResponsive } from '@linqpal/components/src/hooks'
import { useTranslation } from 'react-i18next'
import { View, Text } from 'react-native'
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons'
import InvoiceActionsStore from '../../InvoicesTab/InvoiceActionsStore'

export const Header = () => {
  const { t } = useTranslation('global')
  const { sm } = useResponsive()
  const { setReconnectCreditBank } = InvoiceActionsStore
  return (
    <View
      style={{
        height: sm ? 80 : 70,
        padding: sm ? 22 : 17,
        borderBottomColor: '#EBEEEF',
        borderBottomWidth: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <MaterialCommunityIcons
        name={'close'}
        color={'#003353'}
        size={14}
        style={{
          backgroundColor: '#F5F7F8',
          padding: 10,
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
        }}
        onPress={() => setReconnectCreditBank(false)}
        testID="close"
      />
      <Text
        style={{
          alignSelf: 'center',
          fontWeight: '600',
          fontSize: sm ? 20 : 15,
        }}
      >
        {t('ConnectBankWithPlaid.header')}
      </Text>
      <View />
    </View>
  )
}
